<template>
  <div id="contactos">
    <vue-headful :title="$store.state.option['contacts_title-' + lang]" :lang="lang" />
    <titulo></titulo>
    <!--<div v-if="$store.state.option.googleMaps && $store.state.option.latitude && $store.state.option.longitude">
      <GmapMap :center="{ lat: +$store.state.option.latitude, lng: +$store.state.option.longitude }" :zoom="14" style="height: 300px">
        <GmapMarker :position="google && new google.maps.LatLng(+$store.state.option.latitude, +$store.state.option.longitude)" style="height: 300px"/>
      </GmapMap>
    </div>-->
    <div v-if="$store.state.option.googleMaps && $store.state.option.latitude && $store.state.option.longitude">
      <GmapMap :center="{ lat: +$store.state.option.latitude, lng: +$store.state.option.longitude }" :zoom="14" style="height: 300px">
        <GmapMarker :position="google && new google.maps.LatLng(+$store.state.option.latitude, +$store.state.option.longitude)" style="height: 300px"/>
      </GmapMap>
    </div>
    <div v-if="$store.state.option.linkMapa" v-html="$store.state.option.linkMapa"></div>

    <div class="container">

      <section class="clearfix g-brd-bottom g-brd-gray-light-v4">
      <h4 class="p-t-40">{{$store.state.option['department1_desc_' + lang]}}</h4>
      <!-- Icons Block -->
      <div class="row no-gutters">
        <!-- ADDRESS -->
        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-map"></i>
              </div>
            <div class="center">
              <span class="d-block a-cor" v-html="$store.state.option.morada"></span>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <!-- PHONE -->
        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-phone"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.telefone" :href="'tel:' + $store.state.option.telefone" class="d-block a-cor">{{$store.state.option.telefone}}</a>
              <a v-if="$store.state.option.telefone1" :href="'tel:' + $store.state.option.telefone1" class="d-block a-cor">{{$store.state.option.telefone1}}</a>
              <a v-if="$store.state.option.telefone2" :href="'tel:' + $store.state.option.telefone2" class="d-block a-cor">{{$store.state.option.telefone2}}</a>

              <a v-if="$store.state.option.telemovel" :href="'tel:' + $store.state.option.telemovel" class="d-block a-cor">{{$store.state.option.telemovel}}</a>
              <a v-if="$store.state.option.telemovel1" :href="'tel:' + $store.state.option.telemovel1" class="d-block a-cor">{{$store.state.option.telemovel1}}</a>
              <a v-if="$store.state.option.telemovel2" :href="'tel:' + $store.state.option.telemovel2" class="d-block a-cor">{{$store.state.option.telemovel2}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-envelope"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.email" :href="'mailto:' + $store.state.option.email" class="d-block a-cor">{{$store.state.option.email}}</a>
              <a v-if="$store.state.option.email1" :href="'mailto:' + $store.state.option.email1" class="d-block a-cor">{{$store.state.option.email1}}</a>
              <a v-if="$store.state.option.email2" :href="'mailto:' + $store.state.option.email2" class="d-block a-cor">{{$store.state.option.email2}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-3 col-lg-3">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-globe"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.site" :href="$store.state.option.site" target="_blank" class="d-block a-cor">{{$store.state.option.site}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>
      </div>
      <h4 v-if="$store.state.option['department2_desc_' + lang]" class="p-t-40">{{$store.state.option['department2_desc_' + lang]}}</h4>
      <div v-if="$store.state.option['department2_desc_' + lang]" class="row no-gutters">
        <!-- ADDRESS -->
        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-map"></i>
              </div>
            <div class="center">
              <span class="d-block a-cor" v-html="$store.state.option.morada_dep2"></span>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <!-- PHONES -->
        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-phone"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.telefone_dep2" :href="'tel:' + $store.state.option.telefone_dep2" class="d-block a-cor">{{$store.state.option.telefone_dep2}}</a>
              <a v-if="$store.state.option.telefone1_dep2" :href="'tel:' + $store.state.option.telefone1_dep2" class="d-block a-cor">{{$store.state.option.telefone1_dep2}}</a>
              <a v-if="$store.state.option.telefone2_dep2" :href="'tel:' + $store.state.option.telefone2_dep2" class="d-block a-cor">{{$store.state.option.telefone2_dep2}}</a>

              <a v-if="$store.state.option.telemovel_dep2" :href="'tel:' + $store.state.option.telemovel_dep2" class="d-block a-cor">{{$store.state.option.telemovel_dep2}}</a>
              <a v-if="$store.state.option.telemovel1_dep2" :href="'tel:' + $store.state.option.telemovel1_dep2" class="d-block a-cor">{{$store.state.option.telemovel1_dep2}}</a>
              <a v-if="$store.state.option.telemovel2_dep2" :href="'tel:' + $store.state.option.telemovel2_dep2" class="d-block a-cor">{{$store.state.option.telemovel2_dep2}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-3 col-lg-3 g-brd-right--md g-brd-gray-light-v4">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-envelope"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.email_dep2" :href="'mailto:' + $store.state.option.email_dep2" class="d-block a-cor">{{$store.state.option.email_dep2}}</a>
              <a v-if="$store.state.option.email1_dep2" :href="'mailto:' + $store.state.option.email1_dep2" class="d-block a-cor">{{$store.state.option.email1_dep2}}</a>
              <a v-if="$store.state.option.email2_dep2" :href="'mailto:' + $store.state.option.email2_dep2" class="d-block a-cor">{{$store.state.option.email2_dep2}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-3 col-lg-3">
          <!-- Icon Blocks -->
          <div class="g-py-20 text-center">
            <div class="u-icon-v1 u-icon-size--xl g-color-black g-mb-10">
                <i class="laranja fas fa-globe"></i>
              </div>
            <div class="center">
              <a v-if="$store.state.option.site_dep2" :href="$store.state.option.site_dep2" target="_blank" class="d-block a-cor">{{$store.state.option.site_dep2}}</a>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>
      </div>
      <!-- End Icons Block -->
    </section>
  </div>

    <section class="g-py-100 b-cinzento">
      <div class="container">
        <div class="row justify-content-center p-v-60">
          <div class="col-lg-12">
            <!-- Heading -->
            <div>
              <h2 class="h1 g-color-black g-font-weight-700 text-uppercase text-center">{{$store.state.option['form-' + lang]}}</h2>
              <p class="g-font-size-18 mb-0 text-center">{{$store.state.option['form_desc-' + lang]}}</p>
            </div>
            <!-- End Heading -->
          </div>
        </div>

        <div class="row justify-content-center p-b-60">
          <div class="col-lg-9">
            <form @submit.prevent.stop="function () {return false;}">
              <div class="row">
                <div class="col-md-6 form-group g-mb-20">
                  <input required v-model="form.name" class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="text" :placeholder="$store.state.option['nome-' + lang] + '*'" />
                </div>

                <div class="col-md-6 form-group g-mb-20">
                  <input required v-model="form.email" class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="email" :placeholder="$store.state.option['email1-' + lang] + '*'" />
                </div>

                <div class="col-md-6 form-group g-mb-20">
                  <input required v-model="form.subject" class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="text" :placeholder="$store.state.option['assunto-' + lang] + '*'" />
                </div>

                <div class="col-md-6 form-group g-mb-20">
                  <input v-model="form.phone" class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="tel" :placeholder="$store.state.option['phone1-' + lang]">
                </div>

                <div class="col-md-12 form-group g-mb-40">
                  <textarea required minlength="10" v-model="form.message" class="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover g-resize-none rounded-3 g-py-13 g-px-15" rows="7" :placeholder="$store.state.option['mensgem-' + lang] + '*'"></textarea>
                </div>
              </div>
              <div class="col-md-12 form-check mb-3">
                <input required class="form-check-input" type="checkbox" id="confirm" :disabled="!form.message" v-model="form.confirm">
                <label class="form-check-label" for="confirm" v-html="$store.state.option['contact_acceptance-' + lang]"></label>
              </div>
              <div class="text-center">
                <button type="submit" @click="submit" class="btn btn-primary g-font-weight-600 g-font-size-13 text-uppercase g-rounded-25 g-py-15 g-px-30" role="button">{{$store.state.option['send-' + lang]}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import titulo from '@/components/titulo'
import { mapMutations } from 'vuex'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'

export default {
  components: { titulo },
  data () {
    return {
      form: {
        email: '',
        name: '',
        subject: '',
        phone: '',
        message: '',
        confirm: ''
      },
      lang: ''
    }
  },
  computed: {
    google: gmapApi
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_LOAD1',
      'SET_MAP'
    ]),
    init () {
      if (this.$store.state.option1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['contacts_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['contacts_subtitle-' + this.lang])
        if (!this.$store.state.mapa) {
          this.SET_MAP(true)
          loadGmapApi({
            key: this.$store.state.option['googleMaps'],
            libraries: 'places'
          })
        }
        /*
        if (this.$store.state.option.googleMaps && this.$store.state.option.latitude && this.$store.state.option.longitude) {
          this.$refs.mapRef.$mapPromise.then((map) => {
            // map.panTo({ lat: +this.$store.state.option.latitude, lng: +this.$store.state.option.longitude })
            map.setCenter({ lat: +this.$store.state.option.latitude, lng: +this.$store.state.option.longitude })
            map.setZoom(2)
          })
        }
        */
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    submit () {
      if (this.form.email && this.form.name && this.form.subject && this.form.message && this.form.confirm) {
        this.SET_LOAD1(true)
        this.axios.post('/form', this.form).then((res) => {
          this.form.capa = res.data.image
          this.SET_LOAD1()
          this.SET_TOAST({ msg: this.$store.state.option['form_suc-' + this.lang] })
          this.form = {
            email: '',
            name: '',
            subject: '',
            phone: '',
            message: ''
          }
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      }
    }
  }
}
</script>
